export class AtlonaMs52w {
    constructor(socket, log) {
        this.socket = socket;
        this.analogMute = false;
        this.hdmiMute = false;
        // Set the display port input as default.
        this.masterFirmwareVersion = '2.0';
        this.mcuFirmwareVersion = '1.0.0';
        this.relayState = Array(2).fill(false);
        this.relayDuration = 2;
        this.videoOutputs = Array(16).fill(1);
        this.volume = -20;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /Misc:Versions:Get/i,
                callback: (match) => {
                    const resp = {
                        result: {
                            version: {
                                master: this.masterFirmwareVersion,
                                mcu: this.mcuFirmwareVersion,
                            },
                        },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'modelQuery',
                regExp: /Misc:Model:Get/i,
                callback: (match) => {
                    const resp = {
                        result: { model: 'AT-OME-MS52W' },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'muteQuery',
                regExp: /Audio:Mute:Get/i,
                callback: (match) => {
                    const resp = {
                        result: {
                            outputmute: {
                                hdmi: this.hdmiMute ? true : false,
                                analog: this.analogMute ? true : false,
                            },
                        },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'muteSet',
                regExp: /Audio:Mute:Set\s+(\S+)\s+(true|false)/i,
                callback: (match) => {
                    if (match[1] === 'analog')
                        this.analogMute = match[2] === 'true' ? true : false;
                    else
                        this.hdmiMute = match[2] === 'true' ? true : false;
                    const resp = {
                        result: { success: true },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'outputMode',
                regExp: /OutputMode (.+)/i,
                callback: (match) => {
                    const resp = {
                        result: { state: true },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'relayDurationQuery',
                regExp: /Relay:PulseDuration:Get/i,
                callback: (match) => {
                    const resp = {
                        result: { duration: this.relayDuration },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'relayDurationSet',
                regExp: /Relay:PulseDuration:Set (\d+)/i,
                callback: (match) => {
                    this.relayDuration = parseInt(match[1], 10);
                    const resp = {
                        result: { success: true },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'relayStateQuery',
                regExp: /Relay:State:Get\s+(\d+)/i,
                callback: (match) => {
                    const relayNum = parseInt(match[1], 10);
                    const resp = {
                        result: { state: this.relayState[relayNum] },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'relateStateGet',
                regExp: /Relay:State:Set\s+(\d+)\s+(\d+)/i,
                callback: (match) => {
                    const relayIndex = parseInt(match[1], 10);
                    const relayState = match[2] === '1' ? true : false;
                    this.relayState[relayIndex] = relayState;
                    const resp = {
                        result: { success: true },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'videoQuery',
                regExp: /Display:Matrix:Get\s+(\d+)/i,
                callback: (match) => {
                    // matrix uses zero-based indexing
                    const index = parseInt(match[1], 10);
                    const input = this.videoOutputs[index];
                    const resp = {
                        result: { input: input },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'videoSet',
                regExp: /Display:Matrix:Set\s+(\d+)\s+(\d+)/i,
                callback: (match) => {
                    // Indexes of inputs and outputs are zero-based
                    const outputNum = parseInt(match[2], 10);
                    this.videoOutputs[outputNum] = match[1] ? parseInt(match[1], 10) : 0;
                    const resp = {
                        result: { success: true },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'volumeQuery',
                regExp: /Audio:Volume:Get/i,
                callback: (match) => {
                    const resp = {
                        result: { volume: { value: this.volume, units: 'dB' } },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'volumeSet',
                regExp: /Audio:Volume:Set\s+(-?\d+)/i,
                callback: (match) => {
                    // Indexes of inputs and outputs are zero-based
                    this.volume = parseInt(match[1], 10);
                    const resp = {
                        result: { success: true },
                        methodreturn: match[0].toLowerCase(),
                    };
                    this.socket.send(JSON.stringify(resp));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`Command incorrect`);
                },
            },
        ];
    }
}
AtlonaMs52w.emulatorType = 'socketEmulator';
AtlonaMs52w.key = '-MOYEkDkF7gnN31t-hcE';
